import axios from 'axios';
import {printOnlyInDevelopment} from "../../fanctionUtility";
import * as types from '../actionsTypes/__configActionTypes';
import new_axios_instance from "../../axios_instance";
import {configurationActions, notifsActions} from "../index";

export const getConfigStart = () => async dispatch => {

    await axios.get(`${process.env.NODE_ENV === 'development' ? './conf_dev.json' : './conf.json'}`)
        .then(response => dispatch(getConfigSuccess(response.data)) )
        .catch(e => printOnlyInDevelopment('ERRORE RECUPERO FILE DI CONFIGURAZIONE', e))
};

// export for testing
export const getConfigSuccess = (data) => {
    return {
        type: types.GET_CONFIG_SUCCESS,
        fileConf: data
    }
};

export const getVersionBackEnd = () => async dispatch => {
    await new_axios_instance.get(`/app/version`)
        .then(response => {
            if (response.data != null && response.data !== '') {
                dispatch(configurationActions.getVersionBackEndSuccess(response.data));
            } else {
                dispatch(configurationActions.getVersionBackEndFail());
            }
        })
        .catch(() => {
            dispatch(configurationActions.getVersionBackEndFail());
        });
};

// export for testing
export const getVersionBackEndSuccess = (version) => {
    return {
        type: types.GET_VERSION_BACK_END_SUCCESS,
        versionBackEnd: version
    }
};

// export for testing
export const getVersionBackEndFail = () => {
    return {
        type: types.GET_VERSION_BACK_END_FAIL
    }
};
